module.exports = __webpack_public_path__ + "img/host1.ab7bd431.png";